export const FX_RECEIPT_HEADER = [
  { id: 1, title: 'No.', flex: 1 },
  { id: 2, title: '발행 일시', flex: 2 },
  { id: 3, title: '금액', flex: 2 },
  { id: 4, title: '환율', flex: 2 },
  { id: 5, title: '발행 상태', flex: 2 },
  { id: 6, title: '취소', flex: 2 },
];
